import _ from 'lodash';
import platformUtils from '../platformUtils';
import reporter from '../reporter';
import {generateError} from '../validations/errors';
import {isNilOrEmptyString} from '../utils';

const VECTOR_MEDIA_SRC_REGEX = /^wix:vector:\/\/v1\/([^\/]+)\/([^\/]+)?$/; // this is a hack until WEED-13787 would be solved

const isValidInternalVectorImage = (src) => VECTOR_MEDIA_SRC_REGEX.test(src); // this is a hack until WEED-13787 would be solved

function isValidVectorImage(src) {
    const mediaSrcHandler = platformUtils.getMediaSrcHandler();
    return mediaSrcHandler.isValidMediaSrc(src, mediaSrcHandler.types.VECTOR);
}

function extractModelDataFromSrc(src) { // this is a hack until WEED-13787 would be solved
    const mediaSrcHandler = platformUtils.getMediaSrcHandler();
    const parseMediaItem = mediaSrcHandler.parseMediaSrc(src, mediaSrcHandler.types.VECTOR);
    if (parseMediaItem.error) {
        return null;
    }

    if (!VECTOR_MEDIA_SRC_REGEX.test(src)) {
        return null;
    }

    return {svgId: parseMediaItem.mediaId, title: parseMediaItem.title};
}

function convertToModelFormatAndReportIfError(src, propertyName, functionName, index) { // this is a hack until WEED-13787 would be solved
    const svgData = extractModelDataFromSrc(src);
    if (!svgData) {
        const error = !_.isNil(index) ? generateError.error_bad_svg_format_with_index : generateError.error_bad_svg_format;
        reporter.reportSdkError(error({
            propertyName,
            functionName,
            index,
            wrongValue: src
        }));
        return null;
    }
    return svgData;
}

function convertToMediaSrcAndReportIfError(src, propertyName, functionName, index) {
    if(isNilOrEmptyString(src)){
        return {value: src, isValid: false};
    }

    const isValid = _.isString(src) && isValidVectorImage(src);
    if (!isValid) {
        const error = !_.isNil(index) ? generateError.error_bad_svg_format_with_index : generateError.error_bad_svg_format;
        reporter.reportSdkError(error({
            propertyName,
            functionName,
            index,
            wrongValue: src
        }));
    }
    return {value: src, isValid};
}

function buildFullUrlFromSvgId(svgId, title) {
    const mediaSrcHandler = platformUtils.getMediaSrcHandler();
    const mediaItemUri = mediaSrcHandler.createMediaSrc({mediaId: svgId, type: mediaSrcHandler.types.VECTOR, title});
        if(mediaItemUri.error){
            return svgId;
        }
    return mediaItemUri.item;
}

export default {
    isValidInternalVectorImage,
    convertToMediaSrcAndReportIfError,
    extractModelDataFromSrc,
    convertToModelFormatAndReportIfError,
    buildFullUrlFromSvgId
};
